<template>
  <div class="container-fluid register">
    <div class="container">
      <div class="row">

        <div class="col-lg-4  col-10 col-sm-8 m-auto login-form">
          <router-link to="/" class="content-logo-principal">
          <div style="display:flex;justify-content:center;align-items:center">
              <h1 class="logo-name style-scope page-auth-login">
                <a href="https://royalpag.com/">
                    <img :src="img" style="width: 250px">
                </a></h1>
            </div>
          </router-link>
          <!-- dados para enviar verificar ususario -->
          <div v-if="!isVerificado">
            <h2 class="text-center text-default-gray logo_h2" style="font-size: 16px; font-family: Roboto;">
              Validar dados de cadastro?
            </h2>
            <p class="text-center text-default-gray pt-3 pb-3" style="font-size: 14px; font-family: Roboto; margin-bottom: 0px !important;">Informe o e-mail cadastrado para verificação.</p>
            <div class="card-body pt-3">
              <div class="row">
                <div class="col-12">
                  <form class="well" @submit.prevent="submit">
                    <div class="form-group">
                      <input placeholder="E-mail" type="email" autocomplete="username" class="form-control here" :class="{ invalid: $v.usuario.email.$error }" @input="$v.usuario.email.$touch()" v-model="usuario.email">
                      <span v-if="$v.usuario.email.$dirty && !$v.usuario.email.required" class="invalid">Campo obrigatório!</span>
                      <span v-if="!$v.usuario.email.email" class="invalid">Email inválido!</span>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group">
                          <input type="submit" value="Verificar" :style="color" :disabled="!isWholeModelValid" class="btn btn-primary btn-block mb-3"/>
                        </div>
                      </div>
                    </div>
                    <div style="text-align: center;">
                      <span class="sign-in" style="color: gray;">Já é um membro?  <router-link to="/auth/login" style="padding-left:20px">Entrar</router-link></span>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <!-- dados para enviar verificar ususario -->
          <!-- dados ja verificados -->
          <div v-else>
            <h2 class="text-center text-default-gray logo_h2" style="font-size: 16px; font-family: Roboto;">
              Verificação de conta completa!
            </h2>
            <p class="text-center text-default-gray pt-3 pb-3" style="font-size: 14px; font-family: Roboto; margin-bottom: 0px !important;">Todos seus dados já foram verificados. <br>Obrigado e aproveite nosso portal.</p>
            <div class="row pt-3">
              <div class="col-12">
                <div class="form-group">
                  <input type="reset" @click.prevent="entrar" value="Entrar" :style="color" class="btn btn-primary btn-block mb-3"/>
                </div>
                <div class="form-group">
                  <div v-show="!isWholeRedirect" class="form-group text-center pb-0 mb-0 text-default-gray" style="padding-top: 3px; font-weight: bold">{{contador}}</div>
                </div>
              </div>
            </div>
          </div>
          <!-- dados ja verificados -->
        </div>
      </div><!-- row pai -->
    </div><!-- container -->
  </div><!-- .register class -->
</template>

<script>
  import localforage from 'localforage'
  import { required, email } from 'vuelidate/lib/validators'
  import { mapActions, mapState } from 'vuex'
  import site_style from '@/service/site_style'

  export default {
    name: 'Register',
    data () {
      return {
        img: site_style.getLogo().default,
        color: site_style.getColor(),
        tempoTemp: 10,
        tempo: 10,
        contador: '',
        isVerificado: false,
        usuario: {
          email: '',
          token: '',
          value: '',
          key: ''
        }
      }
    },
    validations: {
      usuario: {
        email: {
          required,
          email
        }
      }
    },
    computed: {
      ...mapState(['logo']),
      isWholeRedirect () {
        return this.tempo === 0
      },
      isWholeModelValid () {
        return !this.$v.$invalid
      }
    },
    methods: {
      ...mapActions(['isUnique']),
      ...mapActions('usuarios', ['solicitarVerificacaoDados']),
      countdown () {
        if ((this.tempo - 1) >= 0) {
          var seg = this.tempo % 60
          if (seg <= 9) {
            seg = '0' + seg
          }
          this.contador = 'Você será redirecionado em: ' + seg + ' segundo(s).'
          setTimeout(() => {
            this.tempo--
            this.countdown()
          }, 1000)
          // console.log(this.tempo, this.isWholeSendSms)
        } else {
          this.tempo = 0
          this.contador = 'Você será redirecionado em: 0 segundo(s).'
          this.$router.push({ name: 'auth.index' })
        }
      },
      entrar () {
        this.$router.push({ name: 'auth.index' })
      },
      async submit () {
        // this.$router.push({ name: 'auth.verificacao' })
        const verb = 'post'
        const tokenAuth = localforage.getItem('I-INA-SYSTEM-AUTH')
        if (Object.getOwnPropertyNames(tokenAuth).length === 0) {
          this.usuario.token = null
        } else {
          this.usuario.token = tokenAuth
        }
        const { usuario } = this
        await this.solicitarVerificacaoDados({ verb, usuario }).then((message) => {
          if (message) {
            localforage.setItem(message.key, message.value)
            if (!message.emailVerificado) {
              this.$router.push({ name: 'auth.email' })
            } else if (!message.codigoSmsVerificado) {
              this.$router.push({ name: 'auth.verificacao' })
            } else {
              this.isVerificado = true
              console.log(this.isVerificado)
              this.countdown()
            }
          }
        })
      }
    },
    mounted () {
    }
  }
</script>

<style src="../../assets/css/login.css" scoped></style>
<style scoped>
  .top25 {
    margin-top: 25px;
  }
  .register {
    padding-top: 3.5%;
    width: 100%;
    height:100vh;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    /* background: radial-gradient(ellipse at center, #5A93AF 0%, #004E74 100%); */
    background-color: #eee;
    overflow-y: auto;
  }
  label[for="terms"]{
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// verificar.vue?96e45a6e